import { useState } from 'react'
import * as React from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'

import { connect, useDispatch } from 'react-redux'
import * as Actions from 'redux/actions'
import { RootState } from 'types'

import { ArticleClient } from 'api/clients/ArticleClient'
import { redirectToLogin } from 'utils/urlUtils'
import Styles from './PasswordRequest.module.scss'
import { ReactComponent as LockIcon } from 'assets/icons/locked24.svg'
import { checkHandbookPassword } from 'api/clients/HandbookClient'
import { setHandbookPassword } from 'hooks/useHandbookPasswords'

interface Props extends RouteComponentProps {
  auth?: RootState['auth']
  fileId: string
  fileType?: string
}

export const PasswordRequest = ({ auth, history, fileId, fileType = 'document' }: Props) => {
  const dispatch = useDispatch()
  const [currentPassword, setCurrentPassword] = useState<string>('')
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const sendPassword = async () => {
    let res: any
    if (fileType === 'document') res = await ArticleClient.checkPassword(fileId, currentPassword)
    if (fileType === 'folder') res = await checkHandbookPassword(fileId, currentPassword)
    return res.type === 'success'
  }

  const handleSubmit = async (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()

      if (currentPassword === '') return

      if (!(await sendPassword())) {
        setErrorMessage('Incorrect Password')
      } else {
        if (fileType === 'document') dispatch(Actions.articlePasswordSet({ key: fileId, value: currentPassword }))
        if (fileType === 'folder') {
          setHandbookPassword(fileId, currentPassword)
          history.go(0)
        }
      }
    }
  }

  const handleChange = (value: string) => {
    setCurrentPassword(value)
    setErrorMessage(null)
  }

  const handleSignInClicked = () => redirectToLogin(history)

  const handleSignUpClicked = () => redirectToLogin(history)

  return (
    <div className={Styles.container}>
      <div className={Styles.centerColumn}>
        <div className={Styles.iconContainer}>
          <LockIcon />
        </div>
        <div className={Styles.headline}>This {fileType} is password protected</div>
        <div className={`${Styles.passwordInputWrapper} ${errorMessage ? Styles.invalidInput : Styles.validInput}`}>
          <label htmlFor="enterPassword">
            <LockIcon />
          </label>
          <input
            id="enterPassword"
            placeholder="Enter password"
            type="password"
            onKeyDown={handleSubmit}
            onChange={({ target: { value } }) => handleChange(value)}
          />
        </div>
        <div className={Styles.errorMessage}>{errorMessage}</div>
        <div className={Styles.reachOutLabel}>Reach out to the owner of the {fileType} to get the password.</div>
        {auth === null && (
          <div className={Styles.signInRequestLabel}>
            You may need to
            <span className={Styles.logInAction} onClick={handleSignInClicked}>
              {' '}
              log in{' '}
            </span>
            or
            <span className={Styles.signUpAction} onClick={handleSignUpClicked}>
              {' '}
              sign up{' '}
            </span>
            to access this {fileType} without the password.
          </div>
        )}
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return { auth: state.auth }
}

export default withRouter(connect(mapStateToProps, null)(PasswordRequest))
